export default {
  justSignUp: {
    message: 'userStatus.registrationCompleted',
    isHtmlMessage: true,
    buttons: [
      {
        label: 'common.confirm',
        action: 'onSignInClick',
        isPrimary: true
      },
      {
        label: 'userStatus.cancelSignUp',
        action: 'onSignUpCancelClick'
      }
    ]
  },
  approved: {
    message: '승인된 계정입니다',
    buttons: [
      {
        label: 'common.confirm',
        action: 'onGoMainClick',
        isPrimary: true
      }
    ]
  },
  notApproved: {
    message: 'userStatus.pendingAccount',
    buttons: [
      {
        label: 'common.confirm',
        action: 'onSignInClick',
        isPrimary: true
      },
      {
        label: 'userStatus.cancelSignUp',
        action: 'onSignUpCancelClick'
      }
    ]
  },
  rejected: {
    message: 'userStatus.declinedAccount',
    buttons: [
      {
        label: 'common.confirm',
        action: 'onSignInClick',
        isPrimary: true
      },
      {
        label: 'userStatus.requestReapproval',
        action: 'onRetryClick'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/data/user-status.js